import authInterceptor from "../AuthInterceptor";

export const historyAPI = {
  // getHistoryList: () =>
  //     authInterceptor.get(`ranking-api/rank-list-history/`)
  //         .then((response) => response.data)
  //         .catch((error) => error.response),
  getHistoryMonths: (config = {}) =>
    authInterceptor
      .get(`ranking-api/rank-list-history/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  getHistoryList: (bodyData = {}) =>
    authInterceptor
      .post(`ranking-api/rank-list-history/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  getMonthHistoryList: (bodyData) =>
    authInterceptor
      .post(`ranking-api/rank-list-history/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  rankHistoryFilter: (bodyData) =>
    authInterceptor
      .post(`ranking-api/rank-list-history/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  exportRankList: (bodyData = {}) =>
    authInterceptor
      .post(`ranking-api/rank-list-history/`, bodyData, {
        responseType: "blob",
      })
      .then((response) => response)
      .catch((error) => Promise.reject(error)),
  getHistoryGridPreferences: (config = {}) =>
    authInterceptor
      .get(`ranking-api/history-grid-preferences/`, config)
      .then((response) => response.data)
      .catch((error) => error.response),
  updateHistoryGridPreferences: (bodyData, config = {}) =>
    authInterceptor
      .put(`ranking-api/history-grid-preferences/`, bodyData, config)
      .then((response) => response.data)
      .catch((error) => error.response),
};
